/**
 * justiceisurrightAccess.ts — SINGLE source of truth for who may view the
 * /justiceisurright tenant workspace.
 *
 * Owner directive (Miles, 2026-07-15, verbatim intent): "/justiceisurright …
 * is only allowed for fernandohidalgo@yahoo.com login account and no public
 * facing either" — while "the chat system on the justiceisurright page
 * should fully work the same as on all pages".
 *
 * Consumed by:
 *   - <JusticeAccessGate> (src/components/JusticeAccessGate.tsx) — the
 *     App.tsx route-level gate that redirects everyone else away;
 *   - src/pages/justiceisurright.tsx — the page's own belt-and-braces
 *     internal gate UI.
 *
 * Do NOT scatter additional copies of these addresses — import from here.
 */

/**
 * Accounts allowed to view /justiceisurright.
 *
 * 'fernandohidalgoesq@yahoo.com' — confirmed by the owner (Miles,
 * 2026-07-15: "I say fernandohidalgoesq@yahoo.com") and consistent with
 * FERNANDO_ATTORNEY_EMAILS / FERNANDO_BRANDING.firmEmail in
 * src/services/tenantBranding.ts.
 */
export const JIU_ALLOWED_EMAILS: ReadonlyArray<string> = Object.freeze([
  'fernandohidalgoesq@yahoo.com',
]);

/**
 * Case-insensitive, whitespace-trimmed membership check against
 * JIU_ALLOWED_EMAILS. Empty / null / undefined never authorizes.
 */
export function isJiuAuthorizedEmail(email: string | null | undefined): boolean {
  const normalized = (email ?? '').trim().toLowerCase();
  if (!normalized) return false;
  return JIU_ALLOWED_EMAILS.some(
    (allowed) => allowed.trim().toLowerCase() === normalized,
  );
}
